import { VISIBILITY_TRACKER_ROUTES } from "@constants"


// Single source of truth for every Visibility Tracker page header so the
// whole module reads consistently: a "Visibility Tracker" section crumb,
// the page name as the title, and a short one-line description.
//
// The layout renders the title block as: `[breadcrumb] title : subtitle`.
// We keep the breadcrumb to a single "Visibility Tracker" crumb (there's
// no dedicated VT landing route to link to) so it acts as an unmistakable
// section label without duplicating the page name that follows.
//
// Usage:  <PageWrapper {...vtPageProps('Review Queue', 'QA pending resources')}>
export function vtPageProps(pageTitle, subtitle = '') {
	return {
		head: `VT · ${pageTitle}`,
		breadcrumb: [{ title: VISIBILITY_TRACKER_ROUTES.TITLE }],
		title: pageTitle,
		subtitle,
	}
}
